export function domain({ commit }, domain) {
  commit("updateDomain", domain);
}
